import classNames from 'classnames/bind';
import React from 'react';
import Autosuggest from 'react-autosuggest';

import { Icon, Grid, Column, Alert } from '../base/Elements';
import { withFormsy } from 'formsy-react';
import { i18n, VARIABLE_REGEXP, SCOPE_REGEXP } from 'common';


export class _AdminTagsInput extends React.Component {
  state = {
    items: [], presets: [], newItem: '',
    error: null, isDirty: false
  }

  validations = {
    isUrl: {
      message: 'error.http-format',
      check: (text) => (
        text.toLowerCase().startsWith('http')
      )
    },
    isVar: {
      message: 'error.var-format',
      check: (text) => (VARIABLE_REGEXP.test(text))
    },
    isScope: {
      message: 'error.scope-format',
      check: (text) => (SCOPE_REGEXP.test(text))
    }
  }

  componentWillMount() {
    this.onItemsLoad(this.props);
  }

  componentWillReceiveProps(props) {
    if (this.state.isDirty)
      return;

    this.onItemsLoad(props);
  }

  onItemsLoad = (props) => {
    const editMode = this.props.editMode||"checkbox";
    const { value: items = [], presets = [] } = props;

    this.setState({ items, presets });
  }

  hasDuplicates = (item) => {
    const { items } = this.state;
    const duplicate = items.find(i => i == item);

    return (duplicate != null);
  }

  onFilter = ({value}) => {
    const { editMode = 'checkbox' } = this.props;

    if (editMode === 'list')
      return [];

    const { presets } = this.props;
    const { items = [] } = this.state;
    const inputValue = value.trim().toLowerCase();
    const isEmpty = !inputValue || inputValue == '';
    const filteredPresets = presets.filter(i => !items.includes(i));

    this.setState({
      presets: isEmpty ? filteredPresets : filteredPresets.filter(i =>
        i.toLowerCase().startsWith(inputValue)
      )
    })
  }

  onClear = () => {
    this.setState({presets: this.props.presets||[]});
  }

  onAppendItem = (ev) => {
    ev.preventDefault();

    const { editMode } = this.props;
    const { newItem: text, items }  = this.state;

    if (text == null || text === '') {
      this.setState({errorMessage: i18n('error.empty-value')})
      return;
    }

    if (this.hasDuplicates(text)) {
      this.setState({errorMessage: i18n('error.duplicate-value')});
      return;
    }

    const { newItemValidations } = this.props;

    if (newItemValidations) {
      for (const validation of Object.entries(this.validations)) {
        const [name, {check, message}] = validation;

        if (newItemValidations.includes(name) && check && !check(text)) {
          this.setState({errorMessage: i18n(message)});
          return;
        }
      }
    }

    this.setState({
      items: [...items, text],
      newItem: '',
      errorMessage: null,
      isDirty: true
    }, this.onSubmit);
  }

  onRemoveItem = (index) => {
    const {items} = this.state;

    items.splice(index, 1);

    this.setState(
      {items: items, isDirty: true}, this.onSubmit);
  }

  onSubmit = () => {
    this.props.setValue(this.state.items);

    (this.props.onChange &&
        this.props.onChange(this.state.items));
  }

  render() {
    const { editMode } = this.props;
    const { presets = [], items = [], errorMessage } = this.state;

    const hasUserItems = this.state.items.length > 0;

    return (
      <Grid columns="2">
        <Column>
          <h2>{this.props.title}</h2>

          <div>
            <div className={classNames({'f-error': this.state.error != null})}>
              <div className="f-group btn-group admin-group">
                <Autosuggest suggestions={presets}
                             onSuggestionsFetchRequested={this.onFilter}
                             onSuggestionsClearRequested={this.onClear}
                             getSuggestionValue={i => i}
                             renderSuggestion={i => (<div>{i}</div>)}
                             inputProps={{
                               placeholder: this.props.placeholder,
                               value: this.state.newItem||'',
                               onChange: (event, {newValue}) => (this.setState({newItem: newValue}))
                             }}
                             shouldRenderSuggestions={() => true}/>


                <button className="btn btn--primary" onClick={this.onAppendItem}>
                  <Icon src="plus" />
                </button>
              </div>

              {errorMessage &&
                <div className="f-error-message">
                  {this.state.errorMessage}
                </div>
              }
            </div>

            <div className="f-group">
            </div>

            <div className="f-group">
              <table>
                <tbody>
                  {items.map((item, index) => (
                    <tr key={index}>
                      <td>{item}</td>
                      <td className="table-70p">
                        <button className="btn btn--danger"
                                onClick={() => this.onRemoveItem(index)}>
                          <Icon src="minus" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Column>

        <Column>
          <div className="mt3">
            <Alert text={this.props.hint}
                   error={i18n('error.empty-list')}
                   type={hasUserItems ? 'info' : 'error'} />
            </div>
          </Column>
      </Grid>
    );
  }
}


export const AdminTagsInput = withFormsy(_AdminTagsInput);
